import { IonButtons, IonCol, IonGrid, IonItemDivider, IonLabel, IonRow } from "@ionic/react";
import { DocumentCount } from "../../SupervisorDocuments/components/DocumentCount";
import { FilterSection } from "./FilterSection";
import { SortSelector } from "../../SupervisorDocuments/components/SortSelector";
import { HojasDeCargoList } from "./HojasDeCargoList";
import { DocumentSearchbar } from "./Searchbar";

export const SupervisorHojaDeCargo: React.FC = () => {
    
  return (
    <section>
      <IonGrid>
        <IonRow>
          <IonCol sizeXs="12" sizeMd="8" sizeLg="6">
            <DocumentSearchbar />
          </IonCol>
        </IonRow>
      </IonGrid>
      <IonGrid>
        <IonRow>
          <IonCol>
            <FilterSection />
          </IonCol>
        </IonRow>
      </IonGrid>
      <section className="ion-padding-horizontal">
        <IonItemDivider class="ion-margin-bottom">
          <IonLabel>
            <h2>
              <DocumentCount />
            </h2>
          </IonLabel>
          <IonButtons slot="end">
            <SortSelector />
          </IonButtons>
        </IonItemDivider>
      </section>
      <HojasDeCargoList/>
    </section>
  );
};
